export default {"src":"/_next/static/media/group3.05d17048.svg","height":13,"width":13,"blurWidth":0,"blurHeight":0};